<template>
  <div>
    <div v-if="treeList">
      <el-cascader
        v-model="inputValue"
        style="width: 100%"
        :options="treeList"
        :props="selectProps"
        :disabled="disabled"
        :clearable="clearable"
        :show-all-levels="false"
        :editable="false"
        @change="handleInputConfirm"
      >
      </el-cascader>
    </div>
    <div v-else-if="!loading" style="margin-bottom: 10px">
      <div>
        <span style="color: #ff0000"> {{ errorMsg || "加载失败" }}</span>
      </div>
      <el-button v-if="errorMsg" @click="fetchTreeList" size="small">
        重新加载
      </el-button>
    </div>
  </div>
</template>

<style scoped>
.tag-item {
  margin-right: 10px;
}

.button-new-tag {
  margin-right: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  margin-right: 10px;
}
</style>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultFirst: {
      type: Boolean,
      default: false,
    },
    storehouseGuid: {
      type: String,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      changeFlag: false,
      inputValue: [],
      treeData: null,
      errorMsg: "",
    };
  },
  watch: {
    value() {
      this.initValue();
    },
    inputValue() {
      this.handleInputConfirm();
    },
  },
  mounted() {
    this.initValue();
    this.fetchTreeList();
  },
  computed: {
    selectProps() {
      return {
        value: "guid",
        label: "name",
        children: "childrenList",
        multiple: this.multiple,
      };
    },
    treeList() {
      let storehouseData = {};
      (this.treeData || []).forEach((tree) => {
        if (tree.storeInfo && tree.storeInfo.optStorehouse == 1) {
          storehouseData[tree.storeInfo.guid] = Object.assign({}, tree.storeInfo, {
            childrenList: [tree.storeInfo],
          });
        }
      });
      (this.treeData || []).forEach((tree) => {
        if (tree.storeInfo && tree.storeInfo.storehouseInfo) {
          if (storehouseData[tree.storeInfo.storehouseGuid]) {
            storehouseData[tree.storeInfo.storehouseGuid].childrenList.push(
              tree.storeInfo
            );
          } else {
            storehouseData[tree.storeInfo.storehouseGuid] = Object.assign(
              {},
              tree.storeInfo.storehouseInfo,
              {
                childrenList: [tree.storeInfo.storehouseInfo, tree.storeInfo],
              }
            );
          }
        }
      });
      return Object.values(storehouseData);
    },
    fullGuids() {
      let guids = [];
      (this.treeList || []).forEach((item) => {
        (item.childrenList || []).forEach((children) => {
          guids.push(children.guid);
        });
      });
      return guids;
    },
  },
  methods: {
    initValue() {
      if (this.changeFlag) {
        this.changeFlag = false;
        return;
      }
      let val = this.value;
      if (
        this.defaultFirst &&
        (this.fullGuids.length > 0 || !val) &&
        this.fullGuids.indexOf(val) < 0
      ) {
        val = this.fullGuids[0];
      }
      let curValue = [];
      (this.treeList || []).forEach((item) => {
        (item.childrenList || []).forEach((children) => {
          if (children.guid == val && val) {
            curValue = [item.guid, children.guid];
          }
        });
      });
      if (this.multiple) {
        this.inputValue = [curValue];
      } else {
        this.inputValue = curValue;
      }
    },
    fetchTreeList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.requestApi(
        "biz.customer.store.info.list",
        {
          storehouseGuid: this.storehouseGuid,
        },
        {
          cache: 1,
          cacheCallback: (resp) => {
            this.handleFetchResp(resp);
          },
        }
      )
        .then((resp) => {
          this.loading = false;
          this.handleFetchResp(resp);
        })
        .catch((err) => {
          this.loading = false;
          this.errorMsg = (err && err.msg) || (err && err.message) || "数据加载失败";
        });
    },
    handleFetchResp(resp) {
      this.treeData = (resp.data.list || []).map((store) => {
        return {
          label: store.name,
          guid: store.guid,
          storeInfo: store,
        };
      });
      this.initValue();
    },
    handleInputConfirm() {
      if (this.loading) {
        return;
      }
      if (this.inputValue.length > 0) {
        if (this.multiple) {
          let newValue = (this.inputValue || [])
            .map((item) => {
              return item[item.length - 1];
            })
            .join(",");
          this.changeFlag = true;
          this.$emit("change", newValue);
        } else {
          this.$emit("change", this.inputValue[this.inputValue.length - 1]);
        }
      } else {
        this.changeFlag = true;
        this.$emit("change", "");
      }
    },
  },
};
</script>
